import NotificationAPI from 'notificationapi-js-client-sdk';
import 'notificationapi-js-client-sdk/dist/styles.css';
import { PopupPosition } from 'notificationapi-js-client-sdk/lib/interfaces';
import { memo, useEffect } from 'react';

const NotificationAPIComponent = memo((props) => {
  useEffect(() => {
    const notificationapi = new NotificationAPI({
      clientId: '3bucjv9lslc63bkdp6fu1929pq',
      userId: props.userId
    });
    notificationapi.showInApp({
      root: 'notificheVS',
      popupPosition: PopupPosition.BottomLeft,
      markAsReadMode: "MANUAL_AND_CLICK"
    });
  }, [props.userId]);

  return <div className='logoNotifiche' id="notificheVS"></div>;
});
export default NotificationAPIComponent;